import { useTranslation } from "react-i18next";
import { useCustomArtStore } from "../../../stores/custom-art-store";
import { useScheduleStore } from "../../../stores/schedule-store";
import { ArtDropzone } from "./ArtDropzone";
import { ArtCreditLine } from "./ArtCreditLine";
import { ArtTransformControls } from "./ArtTransformControls";
import { HandleTransformControls } from "./HandleTransformControls";
import { ArtLayerList } from "./ArtLayerList";

export function ArtSection() {
  const { t } = useTranslation();
  const developerMode = useScheduleStore(state => state.developerMode);
  const selectedId = useCustomArtStore(state => state.selectedId);
  const hasArt = useCustomArtStore(state => state.layers.length > 0);
  const hasHandle = useScheduleStore(state => state.profile.artist_handle.trim().length > 0);

  return (
    <section aria-labelledby="art-heading" className="space-y-3">
      <h2 id="art-heading" className="text-xs font-semibold uppercase tracking-wider">{t("art.title")}</h2>
      <ArtDropzone />
      {hasArt && <>
        <ArtTransformControls key={selectedId} />
        <ArtLayerList />
      </>}
      <div className="space-y-2.5 border-t border-neutral-200 pt-3">
        <ArtCreditLine />
        {!developerMode && hasHandle && <HandleTransformControls />}
      </div>
    </section>
  );
}
